<template>
  <MainFilter
    :filterTitle="`${t('title.sell')} - ${quantities} ${t('title.products')}`"
    :filterText="t('paragraph.sell')"
    :filterQuery="filterQuery"
    v-model:defaultFilter="currentFilter"
    v-model:defaultSortingSettings="sortingSettings"
    :translateHeaders="translateHeaders"
    :productStatus="presetFilter.status"
    :pdfRoute="'to-sale'"
    :hasProducts="quantities > 0"
  />
  <ProductTable
    :actionStatuses="['CP', 'F', 'G', 'I', 'CA']"
    :noRowsText="t('label.noRowsPositive')"
    v-model:filter="currentFilter"
    :sortingSettings="sortingSettings"
    :translateHeaders="translateHeaders"
    :presetFilter="presetFilter"
  />
</template>

<script setup lang="ts">
import MainFilter from "@/components/filter/MainFilter.vue";
import { computed, defineProps, Ref, ref, withDefaults } from "vue";
import { SortingSettings } from "../library/types/sorting/sorting";
import { FilterOptions, PresetFilter } from "../library/types/filter/filter";
import { getQuantitiesByProductStatus } from "@/library/helpers/getQuantitiesByProductStatus";
import ProductTable from "@/components/table/ProductTable.vue";
import { useI18n } from "vue-i18n";

type SalesViewProps = {
  filterQuery?: string;
};

withDefaults(defineProps<SalesViewProps>(), {
  filterQuery: ""
});

const { t } = useI18n();

const quantities = computed(() => {
  return getQuantitiesByProductStatus("S");
});

const sortingSettings: Ref<SortingSettings> = ref({
  col: "updated_at",
  asc: false
});
const translateHeaders = [
  "levkod",
  "kategori_id",
  "skick2",
  "rum",
  "till_rum",
  "main_category"
];
const currentFilter: Ref<FilterOptions> = ref({
  categories: {},
  intervals: {}
});
const presetFilter: PresetFilter = {
  filter: [],
  group: ["benamn", "levkod", "besk", "kategori_id", "green_hash"],
  status: ["S"]
};
</script>
